import { useBreakpointValue } from "@/components/ui/utils/use-break-point-value";
import { Platform } from "react-native";

export function useMobileBreakpoint() {
  const breakpoint: "mobile" | "desktop" = useBreakpointValue({
    default: "mobile",
    md: "desktop",
  }) as any;

  if (breakpoint === 'desktop' && (Platform.OS === 'ios' || Platform.OS === 'android')) {
    return 'mobile';
  }

  return breakpoint;
}
